import React, {FC} from "react"
import {Col} from "react-bootstrap"

import {Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {Team} from "@irati/types"
import Button, {IconButton} from "@irati/ui/src/Button"
import {IconTypes} from "@irati/ui/src/Icon"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import TeamName from "@irati-web/platform/src/components/TeamName"
import theme from "@irati/ui/src/global/theme"

import {FlexRow, FirstCol, EndCol, BrandLogo} from "./styled"

interface Props extends InjectIntl {
  team: Team
  rootTeam: Team
  onSelectTeam: (uuid: string) => void
}

const ProtectedTeamListItem: FC<Props> = ({team, rootTeam, onSelectTeam, onDeleteTeam, formatMessage}) => {
  const branding = team.branding.isEnabled ? team.branding : rootTeam.branding
  return (
    <FlexRow padding={[3, 0, 3]} alignItems="center">
      <FirstCol sm={3}>
        <BrandLogo src={branding.businessLogoUrl} alt="division logo" />
      </FirstCol>
      <Col sm={3}>
        <Body small marginBottom={1}>
          <TeamName team={team} />
        </Body>
      </Col>
      <Col sm={3}>
        <Body small marginBottom={1}>
          {team.users?.total || 0} {formatMessage({id: "admin.containers.protectedTeams.list.activePeople"})}
        </Body>
      </Col>
      <EndCol sm={3}>
        <Flex width="100%" justifyContent="flex-end" alignItems="center">
          <Button small onClick={() => onSelectTeam(team.uuid)}>
            {formatMessage({id: "admin.containers.protectedTeams.list.view"})}
          </Button>
          <IconButton
            id="adminSection_deleteCountry_button"
            inline
            marginLeft
            icon={IconTypes.bin}
            onClick={() => onDeleteTeam(team.uuid)}
            color={theme.colors.tertiary.r_400}
          />
        </Flex>
      </EndCol>
    </FlexRow>
  )
}

export default injectIntl(ProtectedTeamListItem)
